import { Box, CircularProgress, Grid } from "@mui/material";
import { observer, useLocalObservable } from "mobx-react";
import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useRootStore } from "store/StoreContextProvider";
import { UserModel } from "../../domains/models/UserModel";

import { Dialog } from "antd-mobile";
import { EmployeeModel } from "domains/models/EmployeeModel";
import { toJS } from "mobx";
import HomePageStore from "pages/HomePage/store/HomePageStore";
import EmployeeDetailPageStore from "pages/Plugin/store/EmployeeDetailPageStore";
import useSnackbarMessage from "shared/snackbar";
import NoDataImage from '../../assets/image/no-data-icon.svg';
//import LoadExternalScript from "utils/loadExternal";

export interface Props {
  loginPath: string;
}

const LoginByGraphIdPage = (props: Props) => {
  const { loginPath } = props;

  const [isLoading, setIsLoading] = React.useState(true);
  const [alert, setAlert] = React.useState({
    open: false,
    severity: "success",
    message: "",
    title: "",
  });

  const teamsStore = useLocalObservable(() => new EmployeeDetailPageStore());
  const pageStore = useLocalObservable(() => new HomePageStore());
  const { loginStore } = useRootStore();
  const snackbar = useSnackbarMessage();

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const graphId = `${searchParams.get("graphId")}`;

  const conversationType = `${searchParams.get("conversationType")}`;
  const channelId = `${searchParams.get("channelId")}`;
  const teamId = `${searchParams.get("teamId")}`;
  const messageId = `${searchParams.get("messageId")}`;
  const replyToId = `${searchParams.get("replyToId")}`;
  const senderId = `${searchParams.get("senderId")}`;
  const senderName = `${searchParams.get("senderName")}`;

  const hasAttachment = searchParams.get("hasAttachment") === "true";
  const emailChecked = searchParams.get("emailchecked") === "true";
  const teamsChecked = searchParams.get("teamschecked") === "true";

  const MASTER_PASS = "jeisyscross123!";
  const NO_DATA_ON_DB = "본 메시지는 DB에 저장되어 있지 않습니다";

  console.log(`[LOCATION ####>>>] location = ${JSON.stringify(location)}`);

  const signin = async (graphId: string, password: string) => {
    try {
      const response = await loginStore.onLoginByGraphId(graphId, password);
      if (response.user) {
        const user: UserModel = {
          ...response.user,
        };
        loginStore.setCurrentUser(
          user,
          response.accessToken as string,
          response.refreshToken as string
        );

        if (loginPath !== "") {
          await fetchAppraiseeByGraphId();
          //await fetchTargetsByDeptCode();
          await extractOneEmployeeFromList();
        }
      }
    } catch (error) {
      //console.log(error);
      const response = error as {
        code: number;
      };
      if (response.code !== 200) {
        setAlert({
          open: true,
          severity: "error",
          title: "로그인에러",
          message: "사용자 아이디와 바밀번호를 확인하세요.",
        });
      }
    }
  };

  const fetch_and_extract = async () => {
    await fetchAppraiseeByGraphId();
    //await fetchTargetsByDeptCode();
    await extractOneEmployeeFromList();
  }

  const fetchAppraiseeByGraphId = async () => {
    const res = await pageStore.fetchTargetByGraphId(senderId);

    if (pageStore.employeeList.length === 0) {
      Dialog.alert({
        content: "No peers and downwards available.",
        confirmText: "Confirm",
      });
      return;
    }

    await fetchTaskItem();

    if (res?.expired) {
      loginStore.onLogout();
    }
  }

  const fetchTargetsByDeptCode = async () => {
    try {
      //console.log(loginStore.currentUser);
      if (
        loginStore.currentUser?.userData.downwardsList &&
        loginStore.currentUser?.userData.peerList
      ) {
        pageStore.setTabValue("");
      } else if (loginStore.currentUser?.userData.downwardsList) {
        pageStore.setTabValue("downwards");
      } else if (loginStore.currentUser?.userData.peerList) {
        pageStore.setTabValue("peer");
      }

      pageStore.setTabValue("");
      if (loginStore.currentUser) {
        const res = await pageStore.fetchTargetsByDeptCode(
          loginStore.currentUser
        );

        if (pageStore.employeeList.length === 0) {
          Dialog.alert({
            content: "No peers and downwards available.",
            confirmText: "Confirm",
          });
          return;
        }

        await fetchTaskItem();

        if (res?.expired) {
          loginStore.onLogout();
          return;
        }
      } else {
        loginStore.onLogout();
        return;
      }
    } catch (err: any) {
      if (err.response.data === undefined || err.response.data.header.code === 1) {
        showSetupAlert();
      } else {
        snackbar.error(err.message);
      }
    }
  };

  const showSetupAlert = () => {
    Dialog.alert({
      content: `For ${senderName}, please set up a list of peers and subordinates(downwards) in the admin.`,
      confirmText: "Confirm",
    });
  }

  const fetchTaskItem = async () => {
    try {
      const res = await teamsStore.fetchTaskByTeamsMessageId(
        loginStore.currentUser,
        channelId,
        teamId,
        messageId,
        replyToId,
        senderId
      );

      if (res?.expired) {
        loginStore.onLogout();
        return;
      }
    } catch (err: any) {
      snackbar.error(err.message);
    }
  };

  const extractOneEmployeeFromList = async () => {

    for (var employee of pageStore.employeeList) {
      if (employee.userData.graphId === senderId) {
        const nextUrl = location.pathname + location.search;

        if (loginPath === "open" || loginPath === "openlogin") {
          const nextUrl = "/plugin/teams/open" + location.search;
          onOpenAdvice(nextUrl, employee);
        } else if (loginPath === "close" || loginPath === "closelogin") {
          const nextUrl = "/plugin/teams/close" + location.search;
          onCloseAssess(nextUrl, employee);
        }
        setIsLoading(false);
        return;
      }
    }

    setIsLoading(false);
    showSetupAlert();
    return;
  };

  const onOpenAdvice = async (openPath: string, employee: EmployeeModel) => {

    if (!employee) {
      showSetupAlert();
      return;
    }

    let isAccessDone = false;
    if (teamsStore.taskList.length === 0) {
      if (teamsStore.pubDoneList.length === 0) {
        if (teamsStore.prvDoneList.length === 0) {
          snackbar.error(NO_DATA_ON_DB);
          return;
        } else {
          teamsStore.taskList[0] = teamsStore.prvDoneList[0];
        }
      } else {
        isAccessDone = true;
      }
    }

    if (isAccessDone) {
      navigate(openPath, {
        state: {
          employee: toJS(employee),
          task: toJS(teamsStore.pubDoneList[0]),
          assess: toJS(teamsStore.pubAssessList[0]),
          isAssessDone: true
        },
      });
    } else {
      navigate(openPath, {
        state: {
          employee: toJS(employee),
          task: toJS(teamsStore.taskList[0]),
          isAssessDone: false
        },
      });
    }
  };

  const onCloseAssess = async (closePath: string, employee: EmployeeModel) => {
    if (!employee) {
      showSetupAlert();
      return;
    }

    let isAccessDone = false;
    if (teamsStore.taskList.length === 0) {
      if (teamsStore.prvDoneList.length === 0) {
        if (teamsStore.pubDoneList.length === 0) {
          snackbar.error(NO_DATA_ON_DB);
          return;
        } else {
          teamsStore.taskList[0] = teamsStore.pubDoneList[0];
        }
      } else {
        isAccessDone = true;
      }
    }

    if (isAccessDone) {
      navigate(closePath, {
        state: {
          employee: toJS(employee),
          task: toJS(teamsStore.prvDoneList[0]),
          assess: toJS(teamsStore.prvAssessList[0]),
          isAssessDone: true
        },
      });
    } else {
      navigate(closePath, {
        state: {
          employee: toJS(employee),
          task: toJS(teamsStore.taskList[0]),
          isAssessDone: false
        },
      });
    }
  };

  useEffect(() => {

    // script.src="https://res.cdn.office.net/teams-js/2.8.0/js/MicrosoftTeams.min.js"
    // script.integrity="sha384-/DJ9oJEFZSpGiUQx9Na5Yb5svOPPqSb3khKxJ/YgoZ2GtrkzWgSTBpESy3LvMPVk"
    // script.crossOrigin="anonymous"
    const LoadExternalScript = () => {
      const script = document.createElement('script');
      script.src = "https://statics.teams.cdn.office.net/sdk/v1.10.0/js/MicrosoftTeams.min.js";
      script.integrity = "sha384-6oUzHUqESdbT3hNPDDZUa/OunUj5SoxuMXNek1Dwe6AmChzqc6EJhjVrJ93DY/Bv";
      script.setAttribute("crossorigin", "anonymous");
      script.type = 'text/javascript';
      script.innerHTML = "function submitClose() {microsoftTeams.initialize();  microsoftTeams.tasks.submitTask(); } ";
      script.async = true;
      document.body.appendChild(script);
    };
    LoadExternalScript();

    // if (!hasAttachment) {
    //   Dialog.alert({
    //     content: "No attachment available.",
    //     confirmText: "Confirm",
    //     onConfirm: () => {
    //       window.close();
    //       // window.submitClose();
    //       //(window as { [key: string]: any})["submitClose"]();
    //     },
    //   });
    // }

  }, []);

  useEffect(() => {
    if (replyToId && messageId !== replyToId) {
      Dialog.alert({
        content: "Replies cannot be rated.",
        confirmText: "Confirm",
      });
      setIsLoading(false);
      return;
    }

    if (conversationType !== "channel") {
      Dialog.alert({
        content: "Available for team channel only.",
        confirmText: "Confirm",
      });
      setIsLoading(false);
      return;
    }
    if (!loginStore.currentUser && graphId) {
      signin(graphId, MASTER_PASS);
    } else {
      fetch_and_extract();
    }
  }, []);

  /************************************************************************
   * Render
   ************************************************************************/

  return (
    <Box
      sx={{ width: "100%" }}
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="70vh"
    >
      <Grid container justifyContent={"center"} style={{ marginTop: "150px" }}>
        {isLoading && <CircularProgress />}
        {!isLoading && <img src={NoDataImage} style={{ width: 100, height: 100, opacity: 0.5 }} />}
      </Grid>
    </Box>
  );
};

export default observer(LoginByGraphIdPage);
